var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkout-bonuses" },
    [
      _c(
        "h4",
        { staticClass: "checkout-bonuses__title" },
        [
          _vm._v("\n    Клубная программа\n    "),
          _c("info-block", {
            attrs: {
              "is-interactive": "",
              "tooltip-text": _vm.clubProgrammTooltipText
            }
          })
        ],
        1
      ),
      _vm.LOGGED_IN
        ? [
            _c("ui-checkbox", {
              attrs: { value: _vm.isApplied, label: _vm.useBonusesText },
              on: { input: _vm.changeBonusesState }
            })
          ]
        : _c("p", [
            _c("span", { staticClass: "link-blue", on: { click: _vm.login } }, [
              _vm._v("Авторизуйтесь")
            ]),
            _vm._v(" для начисления и использования бонусов.\n  ")
          ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }